// src/pages/User/NewRequest/ui/hook/useReviewStep.ts
import { useMemo } from "react";
import { useFormikContext } from "formik";

import type { FormikInitialValuesNewRequest } from "../../model/form.model";
import { useNewRequestContext } from "../../state/NewRequestProvider";

import { calculateOrderTotals } from "../../domain/calculations/orderTotals";
import { validateOrder } from "../../domain/validators/validateOrder";
import { useNewRequestController } from "./useNewRequestController";

export function useReviewStep() {
  const { action: actionNewRequestController } = useNewRequestController();

  const { state } = useNewRequestContext();

  const formik = useFormikContext<FormikInitialValuesNewRequest>();

  const cart = state.products.cart;
  const pricingStatus = state.products.pricingStatus;
  const customerSelected = Boolean(state.purchase.customer?.id);

  const totals = useMemo(() => calculateOrderTotals(cart), [cart]);

  const validation = useMemo(
    () =>
      validateOrder({
        purchase: formik.values.purchase,
        cart,
        pricingStatus,
        customerSelected,
        customerDetails: state.purchase.customer,
      }),
    [
      formik.values.purchase,
      cart,
      pricingStatus,
      customerSelected,
      state.purchase.customer,
    ]
  );

  const isSubmitting = formik.isSubmitting;
  const canSubmit = validation.ok && !isSubmitting;

  return {
    state: { cart, totals, validation, canSubmit, isSubmitting, pricingStatus },
    action: { reset: actionNewRequestController.resetFlow },
  };
}

export function paymentLabel(payment: "T" | "B", deadline: number) {
  if (payment === "T") return "À vista";
  const d = Number(deadline) || 0;
  return d <= 0 ? "À vista" : `A prazo • ${d} ${d === 1 ? "Dia" : "Dias"}`;
}
